/**
 * Alterna o título da aba entre o título da página (SEO) e uma segunda frase,
 * no estilo de sites como https://www.glean.com/ (título inicial ↔ "Message from …").
 *
 * Ative com data-animate-document-title="true" no <body>.
 * Opcional: data-document-title-alternate="Sua mensagem"
 * Opcional: data-document-title-interval="2800" (ms entre cada troca; padrão 2800)
 */
(function () {
  function init() {
    var body = document.body;
    if (!body) return;

    if (body.getAttribute("data-animate-document-title") !== "true") return;

    var primary = (document.title || "").trim();
    var alternate = (body.getAttribute("data-document-title-alternate") || "Fale com um especialista - Helpcam").trim();

    if (primary.length < 2 || !alternate.length) return;
    if (primary === alternate) return;

    var intervalRaw = body.getAttribute("data-document-title-interval");
    var intervalMs = parseInt(intervalRaw, 10);
    if (!Number.isFinite(intervalMs) || intervalMs < 400) {
      intervalMs = 2800;
    }

    var showingPrimary = true;

    window.setInterval(function () {
      showingPrimary = !showingPrimary;
      document.title = showingPrimary ? primary : alternate;
    }, intervalMs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
